<template>
  <div class="page-container">
    <el-card class="page-content">
      <el-tabs :value="activeTab" @tab-click="handleTabChange">
        <el-tab-pane
          v-if="$hasPerm('tenant:audit_kyc:tab_0')"
          label="未审核"
          name="0"
        ></el-tab-pane>
        <el-tab-pane
          v-if="$hasPerm('tenant:audit_kyc:tab_1')"
          label="审核通过"
          name="1"
        ></el-tab-pane>
        <el-tab-pane
          v-if="$hasPerm('tenant:audit_kyc:tab_2')"
          label="审核不通过"
          name="2"
        ></el-tab-pane>
        <el-tab-pane
          v-if="$hasPerm('tenant:audit_kyc:tab_-1')"
          label="黑名单"
          name="-1"
        ></el-tab-pane>
        <el-tab-pane
          v-if="$hasPerm('tenant:audit_kyc:tab_hight')"
          label="高级认证"
          name="hight"
        ></el-tab-pane>
      </el-tabs>
      <div class="page-actions">
        <el-input
          placeholder="请输入账号ID"
          clearable
          v-model="userId"
          size="mini"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <!-- <el-input placeholder="请输入手机号" clearable v-model="tel">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input> -->
        <el-input
          placeholder="请输入名字"
          clearable
          v-model="realName"
          size="mini"
          v-if="activeTab == 'hight'"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select
          v-model="statusType"
          placeholder="状态"
          clearable
          size="mini"
          v-if="activeTab == 'hight'"
        >
          <el-option
            v-for="(item, index) in typeOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-date-picker
          size="mini"
          v-model="times"
          type="daterange"
          format="yyyy 年 MM 月 dd 日"
          range-separator="至"
          start-placeholder="开始"
          end-placeholder="结束"
          value-format="timestamp"
        ></el-date-picker>
        <el-button type="primary" @click="handleSearch" size="mini"
          >搜索</el-button
        >
        <!-- <el-button :href="downloadLink" @click="downloadTemplate" target="_blank" v-if="this.types != 1"
          >导出Excel</el-button> -->
        <!-- <a @click="exportExcel" target="_blank" v-if="this.types != 1 && this.authType == 0"
          >导出Excel</a
        > -->
      </div>
      <AuditList @refresh="refreshList($event)" :types="types" />
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapState, mapActions } from "vuex";
import AuditList from "./components/list";
import { PAGINATION } from "./constants";
import qs from "qs";

export default {
  name: "KYC",
  data() {
    return {
      userId: null,
      tel: "",
      email: "",
      times: [],
      types: "",
      authType: "0",
      typeOptions: [
        { label: "全部", value: "" },
        // { label: "黑名单", value: "-1" },
        // { label: "未开始", value: "0" },
        // { label: "审核通过", value: "1" },
        // { label: "审核未通过", value: "2" },
        { label: "认证成功", value: "3" },
        { label: "认证失败", value: "4" },
      ],
      statusType: "",
      realName: "",
    };
  },
  components: {
    AuditList,
  },
  computed: {
    ...mapState("kycAudit", ["activeTab", "pagination"]),
    firstVisibleTab() {
      const tabOrder = ["0", "1", "2", "-1", "hight"];
      return tabOrder.find((tab) => this.hasTabPerm(tab)) || null;
    },
    startDate() {
      return this.times && this.times[0]
        ? new Date(new Date(this.times[0]).setHours(0, 0, 0, 0)).getTime()
        : "";
    },
    endDate() {
      return this.times && this.times[1]
        ? new Date(new Date(this.times[1]).setHours(23, 59, 59, 999)).getTime()
        : "";
    },
    downloadLink() {
      const data = {
        type: 0,
        startDate: this.startDate,
        endDate: this.endDate,
        userId: this.userId,
        statusType: this.statusType,
        realName: this.realName,
        tel: this.tel,
        status: this.activeTab,
        ...PAGINATION,
      };
      const params = qs.stringify(data);
      return `/ta/admin/authRecord/export?${params}`;
    },
  },
  methods: {
    ...mapActions("kycAudit", ["list", "getExcel", "getIdOK"]),
    //模板下载

    handleTabChange(tab) {
      if (!this.hasTabPerm(tab.name)) {
        return;
      }
      this.userId = null;
      this.types = tab.name;
      this.tenantId = "";
      this.statusType = "";
      this.realName = "";
      if (tab.name == "hight") {
        this.authType = "1";
        this.types = null;
      } else {
        this.authType = "0";
      }
      this.list({ status: this.types, authType: this.authType, ...PAGINATION });
    },
    handleSearch() {
      this.list({
        startDate: this.startDate,
        endDate: this.endDate,
        userId: this.userId,
        statusType: this.statusType,
        realName: this.realName,
        tel: this.tel,
        status: this.activeTab == "hight" ? null : this.activeTab,
        authType: this.authType,
        ...PAGINATION,
      });
      this.activeTab == "hight" && (this.types = null);
      // if (this.types != 1) {
      //   this.list({
      //     startDate: this.startDate,
      //     endDate: this.endDate,
      //     userId: this.userId,
      //     tel: this.tel,
      //     status: this.activeTab,
      //     ...PAGINATION,
      //   });
      // } else {
      //   this.getIdOK({
      //     startDate: this.startDate,
      //     endDate: this.endDate,
      //     userId: this.userId,
      //     tel: this.tel,
      //     status: this.activeTab,
      //     ...PAGINATION,
      //   });
      // }
    },
    refreshList(data = {}) {
      // if (this.types != 1) {
      this.list({
        startDate: this.startDate,
        endDate: this.endDate,
        userId: this.userId,
        statusType: this.statusType,
        realName: this.realName,
        tel: this.tel,
        status: this.activeTab == "hight" ? null : this.activeTab,
        authType: this.authType,
        ...this.pagination,
        ...data,
      });
      this.activeTab == "hight" && (this.types = null);
      // } else {
      //   this.getIdOK({
      //     status: this.activeTab,
      //     userId: this.userId,
      //     tel: this.tel,
      //     email: this.email,
      //     ...this.pagination,
      //     ...data,
      //   });
      // }
    },
    exportExcel() {
      this.getExcel({
        type: 0,
        startDate: this.startDate,
        endDate: this.endDate,
        userId: this.userId,
        statusType: this.statusType,
        realName: this.realName,
        tel: this.tel,
        status: this.activeTab,
        ...PAGINATION,
      }).then((res) => {
        const link = document.createElement("a");
        const blob = new Blob([res], { type: "application/vnd.ms-excel" }); //设置文件流
        link.style.display = "none";
        // 设置连接
        link.href = URL.createObjectURL(blob); //将文件流转化为blob地址
        console.log("link-href", link.href);
        link.download = "KYC认证统计报表";
        document.body.appendChild(link);
        // 模拟点击事件
        link.click(); //设置点击事件
      });
    },
    hasTabPerm(tabName) {
      const tabPermMap = {
        "0": "tenant:audit_kyc:tab_0",
        "1": "tenant:audit_kyc:tab_1",
        "2": "tenant:audit_kyc:tab_2",
        "-1": "tenant:audit_kyc:tab_-1",
        hight: "tenant:audit_kyc:tab_hight",
      };
      const perm = tabPermMap[tabName];
      return perm ? this.$hasPerm(perm) : false;
    },
    loadByTab(tabName) {
      this.types = tabName;
      this.statusType = "";
      this.realName = "";
      if (tabName === "hight") {
        this.authType = "1";
        this.types = null;
      } else {
        this.authType = "0";
      }
      this.list({
        status: this.types,
        page: 1,
        size: 25,
        authType: this.authType,
      });
    },
  },
  mounted() {
    if (!this.firstVisibleTab) {
      this.$message.warning("当前账号暂无KYC标签页权限");
      return;
    }
    this.loadByTab(this.firstVisibleTab);
  },
};
</script>

<style lang="less" scoped>
.actions-bar {
  display: flex;
  align-items: center;
  .el-input {
    margin-right: 10px;
  }
  .el-button {
    margin-left: 10px;
  }
}
a {
  font-size: 13px;
  margin-left: 10px;
}
</style>
